/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmFineTuningResume } from "../../funcs/llmFineTuningResume.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ResumeFineTuningJobRequest$inboundSchema,
};

export const tool$llmFineTuningResume: ToolDefinition<typeof args> = {
  name: "llm-fine-tuning-resume",
  description: `Resume a fine-tuning job

Resume a paused fine-tuning job.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmFineTuningResume(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
